import type { IRequestConfig } from "@api/config";
import { Controller } from "@api/config";

import {
	IChangePasswordRequest,
	IResetPasswordRequest,
	IRestorePasswordRequest,
	IUserSignInRequest,
} from "./request.types";
import { TUserSignInResponse } from "./response.types";

class AuthenticationController extends Controller {
	public constructor() {
		super({ requestUrl: "models/security/" });
	}

	/**@POST USER SIGN IN */
	public async userSignInAsync({ username, password }: IUserSignInRequest) {
		return this.post<TUserSignInResponse>("auth", { username, password });
	}

	/**@POST USER SIGN OUT */
	public async userSignOutAsync({ token }: IRequestConfig) {
		return this.post<void>("logout", null, { token });
	}

	/**@PUT CHANGE PASSWORD */
	public async changePasswordAsync({ token, oldPassword, newPassword, newPasswordRepeat }: IChangePasswordRequest) {
		return this.put<void>("password", { oldPassword, newPassword, newPasswordRepeat }, { token });
	}

	/**@POST RESTORE PASSWORD */
	public async restorePasswordAsync({ email, username, captchaResponse }: IRestorePasswordRequest) {
		return this.post<void>("restore", { email, username, captchaResponse });
	}

	/**@POST RESET PASSWORD */
	public async resetPasswordAsync({ restoreId, ...data }: IResetPasswordRequest) {
		return this.post<void>(`password/restore/${restoreId}`, data);
	}
}

export const authenticationAPI = new AuthenticationController();
